module.exports = __webpack_public_path__ + "img/ms-square-logo.0024ffce.png";